import React, { useEffect, useMemo, useState } from 'react';
import propTypes from 'prop-types';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'tailwind-components/Modal/Modal';
import withLocalLoader from 'components/HOCs/withLocalLoader';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';
import { getAppointmentsViewData, getCommissions } from 'state/actions/actions';
import {
  APPOINTED_CARRIERS_TAB_ID,
  getCarrierParentGroupTabIds
} from 'helpers/carriers/carriers';
import useTabUrlState from 'hooks/useTabUrlState';
import { ALL_CARRIERS_TAB_ID } from './constants';
import CommissionsStickyHeader from './CommissionsStickyHeader';
import CommissionsCarrierSection from './CommissionsCarrierSection';
import CommissionsTable from './CommissionsTable';

function CommissionRatesView({ setLocalLoader, localLoader }) {
  const dispatch = useDispatch();
  const [active, setActive] = useState('');
  const { carriersArray, appointedCarriers } = useSelector(
    state => state.appointments
  );
  const carrierTabIds = useMemo(
    () => [
      APPOINTED_CARRIERS_TAB_ID,
      ...getCarrierParentGroupTabIds(carriersArray),
      ALL_CARRIERS_TAB_ID
    ],
    [carriersArray]
  );
  const [currentTab, setCurrentTab] = useTabUrlState({
    param: 'tab',
    tabIds: carrierTabIds,
    defaultTabId: ALL_CARRIERS_TAB_ID
  });
  const { commissions } = useSelector(state => state.commissions);
  const cancelTokenSource = axios.CancelToken.source();

  useEffect(() => {
    dispatch(getAppointmentsViewData(setLocalLoader, cancelTokenSource, true));
    return () => {
      cancelTokenSource.cancel('API Call Canceled');
    };
  }, []);

  const handleResetActiveCarrier = () => {
    setActive('');
  };

  const handleCarrierClick = name => {
    const carrierData = carriersArray.find(c => c.name === name);
    dispatch(getCommissions(name, carrierData?.type ?? ''));
    setActive(name);
  };

  return (
    <>
      <div className='h-full w-full min-h-0'>
        <SimpleContainer className='relative h-full min-h-0 gap-4'>
          <CommissionsStickyHeader
            title='Commission Rates'
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
            handleResetActiveCarrier={handleResetActiveCarrier}
          />
          <CommissionsCarrierSection
            currentTab={currentTab}
            activeCarrierName={active}
            onCarrierClick={handleCarrierClick}
            localLoader={localLoader}
            appointedCarriers={appointedCarriers}
          />
        </SimpleContainer>
      </div>

      <Modal
        active={active}
        title={active}
        size='auto'
        isLoading={!commissions[active]}
        closeModal={() => setActive('')}
      >
        <CommissionsTable commissions={commissions[active]} />
      </Modal>
    </>
  );
}

CommissionRatesView.propTypes = {
  setLocalLoader: propTypes.func,
  localLoader: propTypes.bool
};

export default withLocalLoader(
  CommissionRatesView,
  true,
  'Commissions',
  'Commission Rates'
);
